import { z } from 'zod'
import { oc } from '@orpc/contract'
import { pageRequestSchema, pageSchema } from '../../utils/page.contract'
import { taskSchema } from './tasks-shared.contract'

export const listTasks = oc
  .route({ method: 'GET', path: '/v2/tasks' })
  .input(pageRequestSchema)
  .output(z.object({ page: pageSchema, data: z.array(taskSchema) }))
